import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GroupInvoicesService {

  private invoiceGroupSelectUrl = 'InvoiceGroupSelect';
  private vw_InvoiceBulkUpdateGridUrl = 'vw_InvoiceBulkUpdateGrid';
  private vw_InvoiceGroupGridUrl = 'vw_InvoiceGroupGrid';
  private vw_InvoiceGroupGroupedUrl = 'vw_InvoiceGroupGrouped';

  constructor(private http: HttpClient) { }

  getInvoiceGroupSelect(page: number, pageSize: number, sortBy: string, sortDir: string, search: string = "") {
  return this.http.get<any>(
    `${this.invoiceGroupSelectUrl}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&search=${search}`
  );
  }

  getvw_InvoiceBulkUpdateGrid(page: number, pageSize: number, sortBy: string, sortDir: string, search: string = "") {
  return this.http.get<any>(
    `${this.vw_InvoiceBulkUpdateGridUrl}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&search=${search}`
  );
  }

  assignInvoicesToGroup(invoiceIds: number[]) {
    return this.http.post("InvoiceGroup/Assign", invoiceIds);
  }

  getInvoiceGroupGrid(page: number, pageSize: number, sortBy: string, sortDir: string) {
    return this.http.get<any>(
      `${this.vw_InvoiceGroupGridUrl}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}`
    );
  }
  getInvoiceGroupDetails(invoiceGroupId: number, page: number, pageSize: number, sortBy: string, sortDir: string) {
    return this.http.get<any>(`${this.vw_InvoiceGroupGroupedUrl}?invoiceGroupId=${invoiceGroupId}&page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}`);
  }
  removeInvoices(invoiceIds: number[]) {
  return this.http.put("InvoiceGroup/RemoveInvoices", invoiceIds);
  }
  addInvoicesToExistingGroup(data: { invoiceGroupId: number, invoiceIds: number[] }) {
  return this.http.post("InvoiceGroup/AddToGroup", data);
}
  bulkUpdateInvoiceBreakdowns(payload: any) {
    return this.http.put(
      'InvoiceBreakdown/BulkUpdate',
      payload
    );
  }

}
